/**
 * The one sentence that tells an agent their first buyer connection is free.
 * Shared by the Home setup checklist (card + standing-offer steps) and the
 * join offer step so the copy changes in exactly one place.
 */
export const FIRST_CONNECTION_FREE_LINE = "Your first buyer connection is free.";
